import { useState, useEffect, useContext } from 'react';

import { LiveReserveContext } from '../../LiveLessonReseveContext';


// MT講師選択(エラー)
function LiveReserveMtInstructor() {

  const { coachingName } = useContext(LiveReserveContext);


  return (
    <div className="alert alert-danger">
      <small>
        {coachingName}でカスタマイズレッスンを受講中の場合、<br />
        担当講師のライブレッスンの受講をすることはできません。<br />
        カスタマイズレッスンのご予約はLINEまたはカスタマイズレッスン時に担当講師に直接お申し出下さい。<br />
      </small>
    </div>
  );
}
  
export default LiveReserveMtInstructor;